/* import __COLOCATED_TEMPLATE__ from './verification-banner.hbs'; */
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { getIdentityVerificationRequest, hasIdentityVerificationRequest, hasRecasedSSPRequest, hasNeededSSPRequest } from '@banking/ui/utils/risk-utils';
import { open } from '@square/dashboard-utilities/utils/window';
var CDPEvent = /*#__PURE__*/function (CDPEvent) {
  CDPEvent["BannerViewed"] = "unit_message_unit_viewed";
  CDPEvent["BannerClicked"] = "unit_message_unit_clicked";
  return CDPEvent;
}(CDPEvent || {});
var RiskMessageType = /*#__PURE__*/function (RiskMessageType) {
  RiskMessageType["IdentityVerification"] = "IdentityVerification";
  RiskMessageType["SSP"] = "SSP";
  RiskMessageType["SSPRecased"] = "SSPRecased";
  return RiskMessageType;
}(RiskMessageType || {});
let VerificationBanner = (_class = class VerificationBanner extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "applicationRouter", _descriptor, this);
    _initializerDefineProperty(this, "verificationApi", _descriptor2, this);
    _initializerDefineProperty(this, "dataApi", _descriptor3, this);
    _initializerDefineProperty(this, "capitalEngineContext", _descriptor4, this);
    if (this.showVeriffBanner) {
      this.trackIdentityVerification(CDPEvent.BannerViewed);
    } else if (this.showPendingSSPBanner) {
      this.trackSSP(CDPEvent.BannerViewed);
    } else if (this.showRecasedSSPBanner) {
      this.trackRecasedSSP(CDPEvent.BannerViewed);
    }
  }
  get showVeriffBanner() {
    return this.args.riskProfileUnits?.some(unit => hasIdentityVerificationRequest(unit));
  }
  get showPendingSSPBanner() {
    return this.args.riskProfileUnits?.some(unit => hasNeededSSPRequest(unit));
  }
  get showRecasedSSPBanner() {
    return this.args.riskProfileUnits?.some(unit => hasRecasedSSPRequest(unit));
  }
  trackVerificationEvent(event, riskMessageType, riskProfileUnit) {
    this.dataApi.track(event, {
      riskMessageType,
      unitToken: riskProfileUnit.unitToken,
      merchantToken: riskProfileUnit.merchantToken
    });
  }
  trackSSP(event) {
    const riskProfileUnit = this.args.riskProfileUnits?.find(unit => hasNeededSSPRequest(unit));
    if (riskProfileUnit) {
      this.trackVerificationEvent(event, RiskMessageType.SSP, riskProfileUnit);
    }
  }
  trackRecasedSSP(event) {
    const riskProfileUnit = this.args.riskProfileUnits?.find(unit => hasRecasedSSPRequest(unit));
    if (riskProfileUnit) {
      this.trackVerificationEvent(event, RiskMessageType.SSPRecased, riskProfileUnit);
    }
  }
  trackIdentityVerification(event) {
    const riskProfileUnit = this.args.riskProfileUnits?.find(unit => hasIdentityVerificationRequest(unit));
    if (riskProfileUnit) {
      this.trackVerificationEvent(event, RiskMessageType.IdentityVerification, riskProfileUnit);
    }
  }
  openPendingSSP() {
    this.trackSSP(CDPEvent.BannerClicked);
    this.args.goToBusinessInformation();
  }
  openRecasedSSP() {
    this.trackRecasedSSP(CDPEvent.BannerClicked);
    this.args.goToBusinessInformation();
  }
  openVeriff() {
    const riskProfileUnit = this.args.riskProfileUnits?.find(unit => hasIdentityVerificationRequest(unit));
    if (riskProfileUnit) {
      const verificationRequest = getIdentityVerificationRequest(riskProfileUnit);
      if (verificationRequest?.userFormUrl) {
        this.trackIdentityVerification(CDPEvent.BannerClicked);
        open(verificationRequest.userFormUrl, '_blank');
      }
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "applicationRouter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "verificationApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "capitalEngineContext", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "openPendingSSP", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openPendingSSP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openRecasedSSP", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openRecasedSSP"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "openVeriff", [action], Object.getOwnPropertyDescriptor(_class.prototype, "openVeriff"), _class.prototype), _class);
export { VerificationBanner as default };